import { getAllNotifications, disableNotification, makeReadNotifications, getAllNotificationsByUser } from '@/services/notification';

export default {
  getAllNotifications: async ({ commit }) => {
    try {
      const { data } = await getAllNotifications();

      if (data) {
        commit('setAllNotifications', data);
      }
    } catch (error) {
      throw Error("Ocorreu um erro de API.");
    }
  },

  showNotification: ({ commit }, params) => commit('showNotification', params),

  closeNotification: ({ commit }) => commit('closeNotification'),

  disableNotification: async ({ commit }, params) => {
    try {
      const { status } = await disableNotification(params.id);

      if (status === 204) {
        commit('disableNotification', params);
      }
    } catch (error) {
      throw Error("Ocorreu um erro de API.");
    }
  },

  makeReadNotifications: async ({ commit }, params) => {
    try {
      await makeReadNotifications(params.ids);
      commit('makeReadNotifications', params);
    } catch (error) {
      throw Error("Ocorreu um erro de API.");
    }
  },

  getAllNotificationsByUser: async ({ commit }) => {
    try {
      const { data } = await getAllNotificationsByUser();

      if (data) {
        commit('setAllNotificationsByUser', data);
      }
    } catch (error) {
      throw Error("Ocorreu um erro de API.");
    }
  }
};
